export default "__VITE_PUBLIC_ASSET__108a5e6b__"